import {Support, Contacts} from "./Support.component";

export {Support, Contacts};
